var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09441 20.6832C6.59774 17.8784 9.05024 15.75 11.9998 15.75C14.9495 15.75 17.4019 17.8784 17.9053 20.6832C18.3642 20.3705 18.797 20.0224 19.1998 19.6428C18.5814 17.5263 17.055 15.7972 15.0709 14.9056C16.825 13.8584 17.9998 11.9414 17.9998 9.75C17.9998 6.43629 15.3136 3.75 11.9998 3.75C8.68614 3.75 5.99985 6.43629 5.99985 9.75C5.99985 11.9414 7.17465 13.8584 8.9288 14.9056C6.94464 15.7972 5.41834 17.5263 4.79993 19.6428C5.20273 20.0224 5.63553 20.3705 6.09441 20.6832ZM11.9998 14.25C14.4851 14.25 16.4998 12.2353 16.4998 9.75C16.4998 7.26472 14.4851 5.25 11.9998 5.25C9.51456 5.25 7.49985 7.26472 7.49985 9.75C7.49985 12.2353 9.51456 14.25 11.9998 14.25Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.98f93333ce5501eb361b70d50eb693a9.svg";
export { ForwardRef as ReactComponent };